export enum GlobalMenuGroupsRouteNames {
  BRANDS_ROOT = 'GlobalMenuGroupsRoot',
  GLOBAL_MENU_GROUPS_LIST = 'GlobalMenuGroupsRoot/GlobalMenuGroups/List',
  GLOBAL_MENU_GROUPS_DETAILS = 'GlobalMenuGroupsRoot/GlobalMenuGroups/Details',
  GLOBAL_MENU_GROUPS_MANAGEMENT = 'GlobalMenuGroupsRoot/GlobalMenuGroups/Details/Management',
  ARCHIVED_BRANDS = 'GlobalMenuGroupsRoot/GlobalMenuGroups/Details/ArchivedBrands',
  ACTIVE_BRANDS = 'GlobalMenuGroupsRoot/GlobalMenuGroups/Details/ActiveBrands',
  BRAND_DETAILS = 'GlobalMenuGroupsRoot/GlobalMenuGroups/Brand/Details',
  BRAND_MENUS = 'GlobalMenuGroupsRoot/GlobalMenuGroups/Brand/Details/Views',
  BRAND_MENU = 'GlobalMenuGroupsRoot/GlobalMenuGroups/Brand/Details/Views/View',
  BRAND_ITEMS = 'GlobalMenuGroupsRoot/GlobalMenuGroups/Brand/Details/Items',
  BRAND_MODIFIERS = 'GlobalMenuGroupsRoot/GlobalMenuGroups/Brand/Details/Modifiers',
  ENTITY_MANAGEMENT = 'GlobalMenuGroupsRoot/GlobalMenuGroups/Brand/Details/EntityManagement',
  CATEGORY_CHILD_MANAGEMENT = 'GlobalMenuGroupsRoot/GlobalMenuGroups/Brand/Details/Menu/Category/EntityManagement',
  MOD_GROUP_CHILD_MANAGEMENT = 'GlobalMenuGroupsRoot/GlobalMenuGroups/Brand/Details/ModGroup/EntityManagement',
  BRAND_ACTIVITY_LOG = 'GlobalMenuGroupsRoot/GlobalMenuGroups/Brand/Details/Activity',
}
